import type { FC, PropsWithChildren } from "react";

import { MainFooter } from "~/widgets/main-footer";
import { MainHeader } from "~/widgets/main-header";

/**
 *  Старый Layout для приложения (Footer + Header) заполняются из синглтон сущностей
 *  не может быть переопределен для разных страниц
 * @deprecated
 */
export const MainLayout: FC<PropsWithChildren> = ({ children }) => {
  return (
    <main className="min-h-screen flex flex-col justify-between">
      <MainHeader />
      {children}
      <MainFooter />
    </main>
  );
};
